<div *ngIf="section.anchor" style="visibility: hidden;" [id]="section.anchor"></div>
<div
  class="split-section-wrapper"
  [ngStyle]="{ 'grid-template-columns': gridTemplateColumns }"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <div
    class="split-section split-section-left"
    [ngClass]="[type]"
    [class.v-center]="section.left.content.verticalCenter"
    [ngStyle]="{ 'min-width': minWidthLeft }"
  >
    <ng-template
      appComponentFactory
      [name]="section.left.type"
      [section]="section.left.content"
    ></ng-template>
  </div>
  <div
    class="split-section split-section-right"
    [ngClass]="[type]"
    [class.v-center]="section.right.content.verticalCenter"
    [class.right-above-left]="section.rightAboveLeft"
    [ngStyle]="{ 'min-width': minWidthRight }"
  >
    <ng-template
      appComponentFactory
      [name]="section.right.type"
      [section]="section.right.content"
    ></ng-template>
  </div>
</div>
